import React from 'react'
import Header from "../Component/Header";
import Footer from "../Component/Footer"; 
import ActivitiesSidebar from'./ActivitiesSidebar'
import {SlideshowLightbox} from 'lightbox.js-react'
import { Link } from 'react-router-dom'
import LazyLoad from 'react-lazyload';
const SocialOutreach = () => {
  return (
    <>
<Header/>
     <div className="inner_slider">
     <LazyLoad><img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/inner_slider.jpg" className="img-fluid inner_slider_img" alt="St. Xaviers Bathinda"/> </LazyLoad>
     <div className="row bread_cumb">
     <h2>Social Outreach</h2>
     <div className="theme-heading">
     <span className="colorW marB10"><i className="bi bi-building"></i></span>
     </div>
     <h5><Link to="/">Home <i className="bi bi-arrow-right"></i> </Link><span> Activities <i className="bi bi-arrow-right"></i> Social Outreach</span></h5>
     </div>
     
     </div>
     <div className="innerpage">
<div className="row inner_cont">
<div className="col-lg-9 col-md-8 col-sm-12 col-12 memories_sec yeartab">
<h3>Pilar Outreach Foundation Extends Aid to Flood-Affected Villages in Ferozepur.</h3>
<p>On September 4, the Pilar Outreach Foundation, under the leadership of Director Fr. Cidloy Furtado (Principal of St. Xavier’s School, Bathinda), reached out to the flood-affected villages of Ferozepur to provide much-needed relief to families struggling in the aftermath of the disaster. </p>

<p>Carrying ration kits, medicines, sanitary pads and tarpaulins, the team, along with teachers of St. Xavier’s, braved the submerged villages with the help of boats provided by the United Sikhs organization. The outreach became a touching example of inter-religious collaboration and shared humanity. </p>

<p> <b>Baba Balkar Singh (Samaj Sewi) welcomed Fr. Cidloy with a Saroopa.</b> </p>
<p><b> Bhai Gurmeet Singh Ji, along with United Sikhs head Jagmeet Singh ji, personally accompanied the team into the flood-affected areas.</b> </p>
<p>Shri. Balkar Singh (ਵਾਰਿਸ ਪੰਜਾਬ ਦੇ) expressed heartfelt appreciation to the Christian community and the Pilar Outreach Foundation for their humanitarian service. </p>

<p>Fr. Furtado shared, “It was heart-wrenching to see families who have lost their homes and livelihoods, yet their resilience is inspiring.” </p>

<p>He further appreciated all the teachers who accompanied him, Ms. Nupur, who courageously undertook this challenge and Mr. Jagjit, who ensured smooth arrangements and helped in organizing the entire relief operation. </p>

<p>This outreach, carried out on the eve of Teachers’ Day, is sure to leave a lasting impression on students, parents and the wider community — a reminder that service to humanity is the greatest lesson of all. </p>

<p>The United Sikhs acknowledged the efforts of the Pilar Outreach Foundation, highlighting their commitment to serving beyond the boundaries of faith. </p>

<p>Let us all come forward and stand with the people of Punjab in these challenging times. </p>
<div className="row">
<div className="col-lg-4 col-md-4 col-sm-6 col-6 fullwidth550">
  <article>
    <center>
      <LazyLoad><SlideshowLightbox><img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/Flood-Affected_1.jpg" className="img-fluid"/></SlideshowLightbox></LazyLoad>
    </center>
  </article>
</div>
<div className="col-lg-4 col-md-4 col-sm-6 col-6 fullwidth550">
  <article>
    <center>
      <LazyLoad><SlideshowLightbox><img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/Flood-Affected_2.jpg" className="img-fluid"/></SlideshowLightbox></LazyLoad>
    </center>
  </article>
</div>
<div className="col-lg-4 col-md-4 col-sm-6 col-6 fullwidth550">
  <article>
    <center>
      <LazyLoad><SlideshowLightbox><img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/Flood-Affected_3.jpg" className="img-fluid"/></SlideshowLightbox></LazyLoad>
    </center>
  </article>
</div>
<div className="col-lg-4 col-md-4 col-sm-6 col-6 fullwidth550">
  <article>
    <center>
      <LazyLoad><SlideshowLightbox><img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/Flood-Affected_4.jpg" className="img-fluid"/></SlideshowLightbox></LazyLoad>
    </center>
  </article>
</div>
<div className="col-lg-4 col-md-4 col-sm-6 col-6 fullwidth550">
  <article>
    <center>
      <LazyLoad><SlideshowLightbox><img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/Flood-Affected_5.jpg" className="img-fluid"/></SlideshowLightbox></LazyLoad>
    </center>
  </article>
</div>
</div>
        <h3>A Visit to A Slum</h3>
        <p><strong>THEME:  Hygiene, Venue - Dhobiana Basti , Date-29th July 2022 </strong></p>
        <p><strong>“In every community, there is work to be done. In every nation, there are wounds to heal. In every heart, there is the power to do it.”</strong></p>
        <p>The Nukkad Natak programme was organised to raise awareness about the importance of hygiene among the slum dwellers. The students of class V along with the students of the ministry performed a nukkad natak. </p>
        <p>Soaps were distributed among the people.</p>
        <p>The competition was conducted by under the kind supervision of Mrs Mamta Yadav (Advisor of Social Welfare) and Mrs Rajbeer Kaur (Advisor of S.I.G) Mrs. Sonia Jindal (Activity Coordinator) and Miss Nupur (Supervisor).</p>
        <div className="row">
          <div className="col-lg-4 col-md-4 col-sm-6 col-6 fullwidth550">
            <article>
              <center>
                <LazyLoad><SlideshowLightbox><img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/Nukkad_Natak_1.JPG" className="img-fluid"/></SlideshowLightbox></LazyLoad>
              </center>
            </article>
          </div>
          <div className="col-lg-4 col-md-4 col-sm-6 col-6 fullwidth550">
            <article>
              <center>
                <LazyLoad><SlideshowLightbox><img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/Nukkad_Natak_2.JPG" className="img-fluid"/></SlideshowLightbox></LazyLoad>
              </center>
            </article>
          </div>
          <div className="col-lg-4 col-md-4 col-sm-6 col-6 fullwidth550">
            <article>
              <center>
                <LazyLoad><SlideshowLightbox><img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/Nukkad_Natak_3.JPG" className="img-fluid"/></SlideshowLightbox></LazyLoad>
              </center>
            </article>
          </div>
        </div>
        <h3>CELEBRATING 75th INDIA’S INDEPENDENCE WITH 75 SAPLINGS</h3>
        <p>St. Xavier’s School, Bathinda celebrated the 75th Independence day of the country in the most unique manner. Around 20 students from class VIth accompanied with 4 school teachers were taken to an upcoming government school near the stadium and they planted 75 saplings in the premises of the school. The school in collaboration with ‘The Pillar Outreach Foundation’ and ‘Tree lover society’ initiated this movement and the students loved to be a part of the plantation drive. Such practical orientation programmes help the children to be sensitive about the environment and sends a very significant message to the society.</p>
        <div className="row">
          <div className="col-lg-4 col-md-4 col-sm-6 col-6 fullwidth550">
            <article>
              <center>
                <LazyLoad><SlideshowLightbox><img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/outrach_1.JPG" className="img-fluid"/></SlideshowLightbox></LazyLoad>
              </center>
            </article>
          </div>
          <div className="col-lg-4 col-md-4 col-sm-6 col-6 fullwidth550">
            <article>
              <center>
                <LazyLoad><SlideshowLightbox><img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/outrach_2.JPG" className="img-fluid"/></SlideshowLightbox></LazyLoad>
              </center>
            </article>
          </div>
          <div className="col-lg-4 col-md-4 col-sm-6 col-6 fullwidth550">
            <article>
              <center>
                <LazyLoad><SlideshowLightbox><img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/outrach_3.JPG" className="img-fluid"/></SlideshowLightbox></LazyLoad>
              </center>
            </article>
          </div>
        </div>
        <div className="clr"></div>
      </div>
<ActivitiesSidebar/>
</div>
</div>
   <Footer/>
  </>
  )
}

export default SocialOutreach
